import * as THREE from 'three';
import { SHIP_GLOBAL_SCALE, SHIP_TARGET_HEIGHT, SHIP_TARGET_LENGTH, SHIP_TARGET_WIDTH } from './constants.js';

const MAX_SCALE_UP = 3.2; // 避免极端模型被放大过度

/**
 * 调整船只网格尺寸，使其在目标长宽高中占比一致。
 * 若模型过大则缩小，若明显偏小则适度放大。
 */
export function normalizeShipScale(mesh) {
    if (!mesh) return;

    const box = new THREE.Box3().setFromObject(mesh);
    if (box.isEmpty()) return;

    const size = new THREE.Vector3();
    box.getSize(size);

    const ratios = [];
    if (size.x > 0) ratios.push(SHIP_TARGET_WIDTH / size.x);
    if (size.y > 0) ratios.push(SHIP_TARGET_HEIGHT / size.y);
    if (size.z > 0) ratios.push(SHIP_TARGET_LENGTH / size.z);

    if (!ratios.length) return;

    let scaleFactor = Math.min(...ratios);
    if (!Number.isFinite(scaleFactor) || scaleFactor <= 0) return;

    let finalFactor = scaleFactor;

    if (Math.abs(scaleFactor - 1) < 0.05) {
        finalFactor = 1;
    }

    finalFactor *= SHIP_GLOBAL_SCALE;

    if (finalFactor > MAX_SCALE_UP) {
        finalFactor = MAX_SCALE_UP;
    }

    if (Math.abs(finalFactor - 1) < 0.01) {
        return;
    }

    mesh.scale.multiplyScalar(finalFactor);
}
